'use client';

import { useState } from 'react';
import { motion } from 'framer-motion';

import { Button } from '@/components/Default/Button';
import { Header } from '@/components/Default/Title/Header';
import { Section } from '@/components/Default/Section/Section';
import { Title } from '@/components/Default/Title/Title';
import { Description } from '@/components/Default/Title/Description';
import { Link } from '@/components/Default/Link';

const Question = () => {
    const [isInViewport, setInViewport] = useState<boolean>(false);

    return (
        <Section className='bg-primary-200 h-[48rem] sm:h-[40rem] overflow-y-hidden overflow-x-hidden my-0 mb-64' onInViewport={(inViewport: boolean) => setInViewport(inViewport)} inViewOptions={{ once: true }}>
            <div className='absolute top-0 left-0 w-full h-full flex items-center'>
                <div className='w-full max-w-screen-2xl mx-auto px-4 sm:px-16 rounded-2xl text-center'>
                    <Title className='max-w-screen-lg' direction='vertical'>
                        <div>
                            <svg className='inline-block w-32 h-32 md:w-auto md:h-auto' xmlns='http://www.w3.org/2000/svg' viewBox='0 0 512 512' width={160} height={160}>
                                <linearGradient id='5W~O5nGU7nOUp6vx_KxUVa' x1='24' x2='24' y1='32' y2='224' gradientUnits='userSpaceOnUse'>
                                    <stop offset='0' stopColor='#fede00'/>
                                    <stop offset='1' stopColor='#ffd000'/>
                                </linearGradient>
                                <motion.path
                                    fill='#e36001'
                                    d='M288,192a32,32,0,1,1-32,32,32,32,0,0,1,32-32'
                                    initial={{
                                        opacity: 0,
                                        scale: 0
                                    }}
                                    animate={{
                                        opacity: isInViewport ? 1 : 0,
                                        scale: isInViewport ? 1 : 0
                                    }}
                                    transition={{
                                        delay: 0.85
                                    }}
                                />
                                <motion.path
                                    fill='#e36001'
                                    d='M256,112a16,16,0,0,1,16-16A144,144,0,0,1,416,240a16,16,0,0,1-32,0A111.94,111.94,0,0,0,272,128a16,16,0,0,1-16-16'
                                    initial={{
                                        opacity: 0,
                                        x: -8,
                                        y: 8
                                    }}
                                    animate={{
                                        opacity: isInViewport ? 1 : 0,
                                        x: isInViewport ? 0 : -8,
                                        y: isInViewport ? 0 : 8
                                    }}
                                    transition={{
                                        delay: 1
                                    }}
                                />
                                <motion.path
                                    fill='#e36001'
                                    d='M272,0C404.5,0,512,107.5,512,240a16,16,0,0,1-32,0c0-114.9-93.1-208-208-208a16,16,0,0,1,0-32'
                                    initial={{
                                        opacity: 0,
                                        x: -8,
                                        y: 8
                                    }}
                                    animate={{
                                        opacity: isInViewport ? 1 : 0,
                                        x: isInViewport ? 0 : -8,
                                        y: isInViewport ? 0 : 8
                                    }}
                                    transition={{
                                        delay: 1.15
                                    }}
                                />
                                <motion.path
                                    fill='url(#5W~O5nGU7nOUp6vx_KxUVa)'
                                    d='M329,286.7a39.84,39.84,0,0,1,46.7-11.4l112,48a40,40,0,0,1,23.4,45.1l-24,112A40.1,40.1,0,0,1,448,512c-6.1,0-12.2-.1-18.3-.4h-.1c-4.6-.2-9.1-.4-13.7-.8C183.5,494.5,0,300.7,0,64A39.94,39.94,0,0,1,31.6,24.9l112-24a39.93,39.93,0,0,1,45.1,23.4l48,112A40,40,0,0,1,225.3,183l-40.6,33.2A306.6,306.6,0,0,0,295.8,327.3ZM448,480a7.93,7.93,0,0,0,7.8-6.3l24-112a8,8,0,0,0-4.7-9l-112-48a7.86,7.86,0,0,0-9.3,2.3l-33.2,40.6a32,32,0,0,1-40.8,7.4A337.32,337.32,0,0,1,157.1,232.3a32,32,0,0,1,7.4-40.8l40.6-33.2a7.93,7.93,0,0,0,2.3-9.3l-48-112a8,8,0,0,0-9-4.7l-112,24A7.73,7.73,0,0,0,32,64c0,229.6,186.1,415.8,415.7,416Z'
                                    initial={{
                                        opacity: 0,
                                        y: '20%'
                                    }}
                                    animate={{
                                        opacity: isInViewport ? 1 : 0,
                                        y: isInViewport ? '0%' : '20%'
                                    }}
                                    transition={{
                                        delay: 0.65
                                    }}
                                />
                            </svg>
                        </div>
                        <Header align='center' className='mt-8'>
                            Heb je een storing of een vraag?
                        </Header>
                        <Description align='center' className='mt-4 text-primary-950'>
                            Onze vakmensen staan 24/7 voor je klaar om storingen snel en vakkundig op te lossen. Heb je vragen over elektra-installaties of onderhoud? Neem direct contact met ons op voor advies of hulp: <Link>+31 6 40048389</Link>. Wij helpen je graag verder!
                        </Description>
                    </Title>
                    <Button href='tel:+31640048389' label='Bel ons direct op!' size='medium' animated={true} className='hover:bg-orange-700 hover:border-orange-700 ml-auto my-8' />
                </div>
            </div>
        </Section>
    );
};

export default Question;